<template>
  <div class="data-visualisation-tab dashboard-tab">
    <div class="row">
      <div class="col-md-12">
        <vuestic-data-table
          ref="vmTable"
          :apiMode="apiMode"
          :tableData="tableData"
          :tableFields="tableFields"
          :itemsPerPage="itemsPerPage"
          :itemsPerPageLabel="$t('dashboard.perPage')"
          :onEachSide="onEachSide"
          :sortFunctions="sortFunctions"
          :dataModeFilterableFields="dataModeFilterableFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import BadgeColumn from 'components/tables/BadgeColumn.vue'
  import DonutChartData from './DonutChartData'
  import FieldsDef from './fields-definition'
  import CustomActions from './ManageAction'

  Vue.component('manage-custom-actions', CustomActions)
  Vue.component('badge-column', BadgeColumn)

  export default {
    name: 'data-visualisation-tab',
    props: {
      tableData: {
        type: Object,
        default () {
          return {
            data: []
          }
        }
      },
    },
    created () {
      this.tableFields[2].title = this.$t('dashboard.server')
    },
    mounted () {
      this.$refs.vmTable.formatVmStatus = function (value) {
        if (value === 'serverImproving'){
          return this.$t('dashboard.serverImproving')
        }

        if (value === 'running'){
          return  this.$t('management.online')
        }

        if (value !== 'running'){
          return this.$t('management.offline')
        }
      }

      this.$refs.vmTable.formatIp = function (value) {
        return (value && Array.isArray(value)) ? value[0].ip.ip_address : '-'
      }
    },
    data () {
      return {
        donutChartData: DonutChartData,
        apiMode: false,
        sortFunctions: FieldsDef.sortFunctions,
        onEachSide: 1,
        tableFields: FieldsDef.tableFields,
        dataModeFilterableFields: ['hosting_id'],
        itemsPerPage: [
          {
            value: 5
          },
          {
            value: 10
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/mixins/breakpoints";

  .chart-container {
    padding: 0 2rem;
    height: 24rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/dashboard/data-visualisation-tab/DataVisualisation.vue